export const validateUrl = (value: string): boolean => {
  const trimmed = value.trim();
  if (!/^https:\/\//i.test(trimmed)) return false;
  try {
    new URL(trimmed);
    return true;
  } catch {
    return false;
  }
};

export const validateInn = (value: string): boolean => {
  if (!/^\d+$/.test(value)) return false;
  return value.length === 10 || value.length === 12;
};

export const URL_VALIDATION_ERROR =
  "Адрес сайта должен начинаться с https:// (например, https://example.com)";

export const getFilledUrls = (urls: string[]): string[] =>
  urls.map((url) => url.trim()).filter(Boolean);

export interface CreateRequestFormValidation {
  companyNameError: string | null;
  innError: string | null;
  urlErrors: (string | null)[];
  generalError: string | null;
  isValid: boolean;
  filledUrls: string[];
}

export const validateCreateRequestForm = (
  companyName: string,
  inn: string,
  urls: string[],
  remainingChecks: number | null
): CreateRequestFormValidation => {
  let isValid = true;
  let companyNameError: string | null = null;
  let innError: string | null = null;
  let generalError: string | null = null;
  const urlErrors = urls.map(() => null as string | null);

  if (!companyName.trim()) {
    companyNameError = "Наименование не может быть пустым";
    isValid = false;
  }

  if (!validateInn(inn)) {
    innError = "ИНН должен содержать 10 или 12 цифр";
    isValid = false;
  }

  const filledUrls = getFilledUrls(urls);

  if (!filledUrls.length) {
    urlErrors[0] = URL_VALIDATION_ERROR;
    isValid = false;
  } else {
    urls.forEach((url, index) => {
      if (!url.trim()) return;
      if (!validateUrl(url)) {
        urlErrors[index] = URL_VALIDATION_ERROR;
        isValid = false;
      }
    });
  }

  if (isValid && remainingChecks != null && filledUrls.length > remainingChecks) {
    generalError = `Можно создать не более ${remainingChecks} заявок по вашему тарифу`;
    isValid = false;
  }

  return {
    companyNameError,
    innError,
    urlErrors,
    generalError,
    isValid,
    filledUrls,
  };
};
